// extracted by mini-css-extract-plugin
export default {"secondary":"secondary_secondary__+iwHG","secondary--disable":"secondary_secondary--disable__m+Gks"};